// special encodings for floor num
export const floorConstants = {
  1000: {
    floorNum: 1000,
    name: 'Basement',
    sortOrder: -999,
  },
  1001: {
    floorNum: 1001,
    name: 'Rooftop',
    sortOrder: 9999,
  },
  1002: {
    floorNum: 1002,
    name: 'Outside',
    sortOrder: 1001,
  },
  1003: {
    floorNum: 1003,
    name: 'Whole Building',
    sortOrder: 1003,
  },
  1004: {
    floorNum: 1004,
    name: 'Ground Floor',
    sortOrder: 1004,
  },
  1005: {
    floorNum: 1005,
    name: 'Penthouse',
    sortOrder: 9998,
  },
  1006: {
    floorNum: 1006,
    name: 'Atrium',
    sortOrder: 1006, // after Ground Floor
  },
};

export const getFloor = (floorNum) => {
  if (!floorNum) {
    return {
      floorNum,
      name: 'Unknown Location',
      sortOrder: -1000,
    };
  }
  if (floorNum in floorConstants) {
    return floorConstants[floorNum];
  }
  return {
    floorNum,
    name: `Floor ${floorNum}`,
    sortOrder: floorNum,
  };
};
